module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZGUyMTEwIiBkPSJNMCAzNDEuMzMyaDUxMnYxNzAuNjY2SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMnYxNzAuNjY2SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzE5NDAwIiBkPSJNMCAxNzAuNjY2aDUxMnYxNzAuNjY2SDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bg.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bg.svg
// module chunks = 0